<div class="recovery">
    <form class="recovery__form" [formGroup]="recoveryForm" (ngSubmit)="onSubmit()">
        <img alt="menu logo" src="{{LOGO}}" class="img__logo" />
        <h3 class="main-title">Zaboravljena lozinka</h3>
        <div class="form-group">
            <div class="input-group">
                <div class="input-group-prepend" [ngClass]="{
                         'is-invalid': f.email.errors && f.email.touched,
                         'is-valid': f.email.valid && f.email.touched,
                         'input-focus': isEmailInputFocused && !f.email.touched
                     }">
                    <img src="{{USERNAME}}" alt="" class="icon" />
                </div>
                <input type="email" class="form-control bg-grey" formControlName="email"
                    placeholder="Unesite e-mail MaxBet naloga" (focus)="isEmailInputFocused = true"
                    (blur)="isEmailInputFocused = false" [class.is-valid]="f.email.valid && f.email.touched"
                    [class.is-invalid]="f.email.invalid && f.email.touched">
            </div>
            <div *ngIf="f.email.touched && f.email.errors" class="text-danger">
                <div *ngIf="f.email.errors.required && !f.email.value">
                    E-mail je obavezan!
                </div>
                <div *ngIf="f.email.errors.email && f.email.value">
                    Unos nije validan!
                </div>
            </div>
        </div>
        <div class="button__container">
            <button type="submit" class="buttons btn--orange"
                [disabled]="!recoveryForm.valid || spinnerService.spinnerVisible">
                Resetuj
                <app-button-spinner></app-button-spinner>
            </button>
            <a routerLink="/{{LOGIN_ROUTE}}" class="login__link">Prijavi se</a>
        </div>
    </form>
</div>